var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fin-portfolio-distribution-chart',{attrs:{"series-object":_vm.seriesObject,"title":"Assetklassen"}})}
var staticRenderFns = []

export { render, staticRenderFns }